module.exports = __webpack_public_path__ + "img/icon_footer_fifa_unselect.537ecfd3.png";